export default {
  getAssignedCases: inspectorId => `/inspector-case/${inspectorId}/assigned`,
  getAssignedCasesByEmployeeId: employeeId => `/inspector-case/employee/${employeeId}/assigned`,
  getCaseAppointments: inspectorId => `/inspector-case/${inspectorId}/appointments`,
  postExtensionRequest: controlIdNumber => `/inspector-case/cases/${controlIdNumber}/extensions`,
};
